// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetVariantViewParameter } from "@store/Framework/Store/Store/Pages/ProductDetails/Handlers/setVariantView";
import ProductDetailsState from "@store/Framework/Store/Store/Pages/ProductDetails/ProductDetailsState";
import { Draft } from "immer";

const initialState: ProductDetailsState = {
    variantView: undefined,
};

const actions = {
    "Store/Pages/ProductDetails/SetVariantView": (
        draft: Draft<ProductDetailsState>,
        action: SetVariantViewParameter,
    ) => {
        draft.variantView = action.view;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ProductDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
